// Firebase Functions base URL loaded from environment.
const FUNCTIONS_BASE_URL = (
  process.env.REACT_APP_FIREBASE_FUNCTIONS_URL || ''
).replace(/\/+$/, '');

export { FUNCTIONS_BASE_URL };
